import { render, staticRenderFns } from "./gateways-filter.vue?vue&type=template&id=2aa09a12"
import script from "./gateways-filter.vue?vue&type=script&lang=js"
export * from "./gateways-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports